import React, { useState } from 'react'
import Modal from '../Modal/Modal'
import API from '../../services/apiService'
import { useTranslation } from '../../i18n/LanguageContext'
import './AuthModal.css'

// Medieval SVG Icons
const KnightIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" className="auth__svg-icon">
    <defs>
      <linearGradient id="knightGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <circle cx="12" cy="7" r="5" fill="url(#knightGold)"/>
    <path d="M12 4 L12 2 M9 5 L7 3 M15 5 L17 3" stroke="#c9a227" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M4 22 C4 16 8 13 12 13 C16 13 20 16 20 22" fill="url(#knightGold)"/>
    <rect x="10" y="14" width="4" height="6" fill="#4a3020"/>
  </svg>
)

const ScrollIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" className="auth__svg-icon">
    <defs>
      <linearGradient id="scrollPaper" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#f5edd8"/>
        <stop offset="100%" stopColor="#d4c5a9"/>
      </linearGradient>
    </defs>
    <path d="M6 4 C4 4 3 5 3 6 L3 7 C3 8 4 9 6 9 L6 19 C6 20 7 21 8 21 L18 21 C19 21 20 20 20 19 L20 18 C20 17 19 16 18 16 L18 6 C18 5 17 4 16 4 Z" 
      fill="url(#scrollPaper)" stroke="#8b7355" strokeWidth="1"/>
    <path d="M3 6 C3 5 4 4 6 4" stroke="#a08060" strokeWidth="2" fill="none"/>
    <path d="M20 19 C20 20 19 21 18 21" stroke="#a08060" strokeWidth="2" fill="none"/>
    <line x1="8" y1="8" x2="16" y2="8" stroke="#8b7355" strokeWidth="1"/>
    <line x1="8" y1="11" x2="14" y2="11" stroke="#8b7355" strokeWidth="1"/>
    <line x1="8" y1="14" x2="15" y2="14" stroke="#8b7355" strokeWidth="1"/>
  </svg>
)

const KeyIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" className="auth__svg-icon">
    <defs>
      <linearGradient id="keyGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <circle cx="8" cy="8" r="5" fill="none" stroke="url(#keyGold)" strokeWidth="2.5"/>
    <circle cx="8" cy="8" r="2" fill="url(#keyGold)"/>
    <path d="M12 12 L20 20" stroke="url(#keyGold)" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M17 17 L19 15" stroke="url(#keyGold)" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M15 19 L17 17" stroke="url(#keyGold)" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
)

const LockIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" className="auth__svg-icon">
    <defs>
      <linearGradient id="lockGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <rect x="5" y="11" width="14" height="10" rx="2" fill="url(#lockGold)" stroke="#5a4510" strokeWidth="1"/>
    <path d="M8 11 L8 7 C8 4 10 2 12 2 C14 2 16 4 16 7 L16 11" fill="none" stroke="url(#lockGold)" strokeWidth="2.5"/>
    <circle cx="12" cy="16" r="2" fill="#2a1a10"/>
    <path d="M12 16 L12 19" stroke="#2a1a10" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

const SwordIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" className="auth__svg-icon">
    <defs>
      <linearGradient id="swordBlade2" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#d0d0d0"/>
        <stop offset="50%" stopColor="#ffffff"/>
        <stop offset="100%" stopColor="#a0a0a0"/>
      </linearGradient>
    </defs>
    <path d="M4 4 L6 6 L6 14 L4 16 L2 14 L2 6 Z" fill="url(#swordBlade2)" stroke="#666" strokeWidth="0.5" transform="rotate(45 12 12)"/>
    <rect x="10" y="14" width="4" height="2" fill="#c9a227" transform="rotate(45 12 12)"/>
    <rect x="11" y="16" width="2" height="4" fill="#4a3020" transform="rotate(45 12 12)"/>
    <circle cx="12" cy="20" r="1.5" fill="#c9a227" transform="rotate(45 12 12)"/>
  </svg>
)

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" className="auth__svg-icon">
    <defs>
      <linearGradient id="shieldGold2" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#e6c84a"/>
        <stop offset="50%" stopColor="#c9a227"/>
        <stop offset="100%" stopColor="#8b6914"/>
      </linearGradient>
    </defs>
    <path d="M12 2 L20 5 L20 11 C20 17 12 22 12 22 C12 22 4 17 4 11 L4 5 Z" 
      fill="url(#shieldGold2)" stroke="#5a4510" strokeWidth="1.5"/>
    <path d="M12 5 L17 7 L17 11 C17 15 12 19 12 19 C12 19 7 15 7 11 L7 7 Z" 
      fill="#2a1a10"/>
    <path d="M12 8 L12 16 M9 12 L15 12" stroke="#c9a227" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

const AuthModal = ({ isOpen, onClose, onLogin, initialMode = 'login', resetToken = null, unverifiedEmail = null, onSetUnverifiedEmail = null }) => {
  const { t } = useTranslation()
  const [mode, setMode] = useState(initialMode) // 'login', 'register', 'verify-email', 'forgot', 'reset', 'change-temp-password'
  const [entered, setEntered] = useState(false)
  
  React.useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => setEntered(true), 350)
      return () => {
        clearTimeout(timer)
        setEntered(false)
      }
    } else {
      setEntered(false)
    }
  }, [isOpen])
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    verificationCode: '',
    resetToken: resetToken || ''
  })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [registrationEmail, setRegistrationEmail] = useState(unverifiedEmail || '') // Store email for display
  const [registrationUsername, setRegistrationUsername] = useState('') // Store username for verification
  const [remainingAttempts, setRemainingAttempts] = useState(5) // Track verification attempts
  const [codeExpiry, setCodeExpiry] = useState(null) // Track code expiration time
  const [timeRemaining, setTimeRemaining] = useState(null) // Display time remaining
  const [loginAttemptEmail, setLoginAttemptEmail] = useState('') // Store email from failed login attempt
  const [animating, setAnimating] = useState(null) // 'exiting', 'entering', or null
  const [submitCount, setSubmitCount] = useState(0)
  const [tempToken, setTempToken] = useState('')

  // Update mode if initialMode prop changes
  React.useEffect(() => {
    if (initialMode) {
      setMode(initialMode)
    }
  }, [initialMode])

  // Update resetToken if prop changes
  React.useEffect(() => {
    if (resetToken) {
      setFormData(prev => ({ ...prev, resetToken }))
    }
  }, [resetToken])

  // Handle unverified email from failed login
  React.useEffect(() => {
    if (unverifiedEmail) {
      setRegistrationEmail(unverifiedEmail)
      setMode('verify-email')
      setCodeExpiry(Date.now() + 15 * 60 * 1000) // Set 15-minute expiry
      setRemainingAttempts(5)
      setError('')
      setSuccessMessage(t('auth.emailNeedsVerification'))
      // Clear the unverified email state after handling
      if (onSetUnverifiedEmail) {
        onSetUnverifiedEmail(null)
      }
    }
  }, [unverifiedEmail, onSetUnverifiedEmail])

  // Timer countdown for code expiration
  React.useEffect(() => {
    if (!codeExpiry || mode !== 'verify-email') {
      setTimeRemaining(null)
      return
    }

    const updateTimer = () => {
      const now = Date.now()
      const remaining = Math.max(0, codeExpiry - now)
      
      if (remaining <= 0) {
        setTimeRemaining('expired')
        setError(t('auth.verificationCodeExpired'))
        return
      }

      const minutes = Math.floor(remaining / 60000)
      const seconds = Math.floor((remaining % 60000) / 1000)
      setTimeRemaining(`${minutes}:${seconds.toString().padStart(2, '0')}`)
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)

    return () => clearInterval(interval)
  }, [codeExpiry, mode])

  const handleChange = (e) => {
    const { name, value } = e.target
    
    // For verification code, only allow digits and max 6 characters
    if (name === 'verificationCode') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 6)
      setFormData({
        ...formData,
        [name]: digitsOnly
      })
    } else {
      setFormData({
        ...formData,
        [name]: value
      })
    }
    
    setError('')
    setSuccessMessage('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitCount(c => c + 1)
    setLoading(true)

    try {
      if (mode === 'login') {
        // Login with API
        const result = await API.Auth.login(formData.username, formData.password)
        
        if (result.success) {
          // Check if password is temporary (admin reset)
          if (result.mustChangePassword) {
            setTempToken(result.tempToken)
            setMode('change-temp-password')
            setFormData(prev => ({ ...prev, password: '', confirmPassword: '' }))
            setError('')
            setSuccessMessage(t('auth.passwordIsTemporary'))
            setLoading(false)
            return
          }
          onLogin(result.user)
          onClose()
          resetForm()
        } else {
          // Check if error is due to unverified email
          const errorMsg = result.error?.message || result.error || ''
          if (errorMsg.toLowerCase().includes('email not verified') || 
              (errorMsg.toLowerCase().includes('email') && errorMsg.toLowerCase().includes('verified'))) {
            // Store username for verification
            setRegistrationUsername(formData.username)
            setRegistrationEmail(result.email || result.data?.email || 'your email')
            setMode('verify-email')
            setCodeExpiry(Date.now() + 15 * 60 * 1000) // Set 15-minute expiry
            setRemainingAttempts(5)
            setError('')
            setSuccessMessage(t('auth.emailNeedsVerification'))
            setFormData(prev => ({ ...prev, verificationCode: '' }))
          } else {
            setError(result.error || t('auth.loginFailed'))
          }
        }
      } else if (mode === 'register') {
        // Register validation
        if (formData.password !== formData.confirmPassword) {
          setError(t('auth.passwordsDoNotMatch'))
          setLoading(false)
          return
        }
        
        if (formData.password.length < 6) {
          setError(t('auth.passwordMinLength'))
          setLoading(false)
          return
        }
        
        if (!formData.email.includes('@')) {
          setError(t('auth.validEmailRequired'))
          setLoading(false)
          return
        }

        // Register with API
        const result = await API.Auth.register(
          formData.username,
          formData.password,
          formData.email
        )
        
        if (result.success) {
          // Store email and username for verification
          setRegistrationEmail(formData.email)
          setRegistrationUsername(formData.username)
          // Set code expiry (15 minutes from now)
          setCodeExpiry(Date.now() + 15 * 60 * 1000)
          // Reset attempts counter
          setRemainingAttempts(5)
          // Switch to email verification mode
          setMode('verify-email')
          setSuccessMessage(
            result.message || 
            t('auth.registrationSuccess')
          )
          // Clear form except email
          setFormData(prev => ({
            username: '',
            email: prev.email,
            password: '',
            confirmPassword: '',
            verificationCode: '',
            resetToken: ''
          }))
        } else {
          setError(result.error || t('auth.registrationFailed'))
        }
      } else if (mode === 'verify-email') {
        // Email verification with 6-digit code
        if (!formData.verificationCode || formData.verificationCode.length !== 6) {
          setError(t('auth.verificationFailed'))
          setLoading(false)
          return
        }

        const result = await API.Auth.verifyEmail(registrationUsername, formData.verificationCode)
        
        if (result.success) {
          setSuccessMessage(t('auth.verificationSuccess'))
          setCodeExpiry(null)
          setTimeout(() => {
            setMode('login')
            setSuccessMessage('')
            resetForm()
            setRegistrationEmail('')
            setRemainingAttempts(5)
          }, 2000)
        } else {
          // Update remaining attempts if provided
          if (result.remainingAttempts !== undefined) {
            setRemainingAttempts(result.remainingAttempts)
          }
          setError(result.error || t('auth.verificationFailed'))
        }
      } else if (mode === 'forgot') {
        // Forgot Password - Request reset email
        if (!formData.email.includes('@')) {
          setError(t('auth.validEmailRequired'))
          setLoading(false)
          return
        }

        const result = await API.Auth.forgotPassword(formData.email.trim())
        
        if (result.success) {
          // Show success message with helpful instructions
          setSuccessMessage(t('auth.resetLinkSent'))
          setTimeout(() => {
            setMode('login')
            setSuccessMessage('')
            resetForm()
          }, 6000)
        } else {
          // Display API error if provided, otherwise generic message
          setError(
            result.error || 
            t('auth.resetLinkFailed')
          )
        }
      } else if (mode === 'reset') {
        // Reset Password - Set new password with token
        if (formData.password.length < 6) {
          setError(t('auth.passwordMinLength'))
          setLoading(false)
          return
        }

        if (formData.password !== formData.confirmPassword) {
          setError(t('auth.passwordsDoNotMatch'))
          setLoading(false)
          return
        }

        const token = formData.resetToken
        if (!token) {
          setError(t('auth.invalidResetLink'))
          setLoading(false)
          return
        }

        const result = await API.Auth.resetPassword(token, formData.password)
        
        if (result.success) {
          setSuccessMessage(t('auth.resetSuccess'))
          setTimeout(() => {
            setMode('login')
            setSuccessMessage('')
            resetForm()
          }, 3000)
        } else {
          setError(result.error || t('auth.resetFailed'))
        }
      } else if (mode === 'change-temp-password') {
        // Change temporary password after admin reset
        if (formData.password.length < 6) {
          setError(t('auth.passwordMinLength'))
          setLoading(false)
          return
        }

        if (formData.password !== formData.confirmPassword) {
          setError(t('auth.passwordsDoNotMatch'))
          setLoading(false)
          return
        }

        const result = await API.Auth.changeTempPassword(tempToken, formData.password)

        if (result.success) {
          onLogin(result.user)
          onClose()
          resetForm()
          setTempToken('')
        } else {
          setError(result.error || t('auth.changePasswordFailed'))
        }
      }
    } catch (err) {
      setError(t('auth.unexpectedError'))
      console.error('Auth error:', err)
    } finally {
      setLoading(false)
    }
  }

  const resetForm = () => {
    setFormData({
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      verificationCode: '',
      resetToken: ''
    })
    setError('')
    setSuccessMessage('')
    setTempToken('')
  }

  const handleResendVerification = async () => {
    if (!registrationUsername) {
      setError(t('auth.usernameNotFound'))
      return
    }

    setLoading(true)
    setError('')
    setSuccessMessage('')

    try {
      const result = await API.Auth.resendVerification(registrationUsername)
      
      if (result.success) {
        // Reset code expiry (15 minutes from now)
        setCodeExpiry(Date.now() + 15 * 60 * 1000)
        // Reset attempts counter
        setRemainingAttempts(5)
        // Clear the code input
        setFormData(prev => ({ ...prev, verificationCode: '' }))
        setSuccessMessage(t('auth.resendSuccess'))
      } else {
        setError(result.error || t('auth.resendFailed'))
      }
    } catch (err) {
      setError(t('auth.unexpectedError'))
      console.error('Resend verification error:', err)
    } finally {
      setLoading(false)
    }
  }

  const switchMode = (newMode) => {
    const targetMode = typeof newMode === 'string' ? newMode : (mode === 'login' ? 'register' : 'login')
    if (targetMode === mode) return

    const modeOrder = ['login', 'register', 'verify-email', 'forgot', 'reset', 'change-temp-password']
    const isForward = modeOrder.indexOf(targetMode) > modeOrder.indexOf(mode)

    setAnimating(isForward ? 'exiting-left' : 'exiting-right')
    setTimeout(() => {
      setMode(targetMode)
      setError('')
      setSuccessMessage('')
      if (targetMode === 'register') {
        setFormData(prev => ({ ...prev, username: '', password: '', confirmPassword: '', email: '' }))
      } else if (targetMode !== 'login' && targetMode !== 'reset' && targetMode !== 'change-temp-password') {
        setFormData(prev => ({ ...prev, password: '', confirmPassword: '' }))
      }
      if (targetMode !== 'change-temp-password') {
        setTempToken('')
      }
      setAnimating(isForward ? 'entering-right' : 'entering-left')
      setTimeout(() => setAnimating(null), 250)
    }, 180)
  }

  // Get modal title based on mode
  const getModalTitle = () => {
    switch (mode) {
      case 'login': return t('auth.enterRealm')
      case 'register': return t('auth.joinGuild')
      case 'verify-email': return t('auth.verifyEmail')
      case 'forgot': return t('auth.recoverAccount')
      case 'reset': return t('auth.createNewPassword')
      case 'change-temp-password': return t('auth.setNewPassword')
      default: return t('auth.authentication')
    }
  }

  // Get submit button text and icon based on mode
  const getSubmitContent = () => {
    switch (mode) {
      case 'login': return { icon: <SwordIcon />, text: t('auth.enter') }
      case 'register': return { icon: <ShieldIcon />, text: t('auth.createAccount') }
      case 'verify-email': return { icon: <ScrollIcon />, text: t('auth.verifyEmailBtn') }
      case 'forgot': return { icon: <ScrollIcon />, text: t('auth.sendResetLink') }
      case 'reset': return { icon: <KeyIcon />, text: t('auth.resetPassword') }
      case 'change-temp-password': return { icon: <KeyIcon />, text: t('auth.setNewPasswordBtn') }
      default: return { icon: <SwordIcon />, text: t('auth.submit') }
    }
  }

  const submitContent = getSubmitContent()

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title={getModalTitle()}
    >
      <div className={`auth${animating === 'exiting-left' ? ' auth--exiting-left' : ''}${animating === 'exiting-right' ? ' auth--exiting-right' : ''}${animating === 'entering-right' ? ' auth--entering-right' : ''}${animating === 'entering-left' ? ' auth--entering-left' : ''}`}>
        <form className={`auth__form${entered ? '' : ' auth__form--entering'}`} onSubmit={handleSubmit}>
          {/* Username - Only for login and register */}
          {(mode === 'login' || mode === 'register') && (
            <div className="auth__field">
              <label className="auth__label">
                <KnightIcon />
                {t('auth.username')}
              </label>
              <input
                type="text"
                name="username"
                className="auth__input"
                placeholder={t('auth.usernamePlaceholder')}
                value={formData.username}
                onChange={handleChange}
                required
                autoComplete="username"
              />
            </div>
          )}

          {/* Email - For register and forgot password */}
          {(mode === 'register' || mode === 'forgot') && (
            <div className="auth__field">
              <label className="auth__label">
                <ScrollIcon />
                {t('auth.email')}
              </label>
              <input
                type="email"
                name="email"
                className="auth__input"
                placeholder={mode === 'forgot' ? t('auth.forgotEmailPlaceholder') : t('auth.emailPlaceholder')}
                value={formData.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />
              {mode === 'forgot' && (
                <p className="auth__hint">
                  {t('auth.forgotHint')}
                </p>
              )}
            </div>
          )}

          {/* Password - For login, register, reset, and change-temp-password */}
          {(mode === 'login' || mode === 'register' || mode === 'reset' || mode === 'change-temp-password') && (
            <div className="auth__field">
              <label className="auth__label">
                <KeyIcon />
                {(mode === 'reset' || mode === 'change-temp-password') ? t('auth.newPassword') : t('auth.password')}
              </label>
              <input
                type="password"
                name="password"
                className="auth__input"
                placeholder={mode === 'reset' ? t('auth.newPasswordPlaceholder') : mode === 'change-temp-password' ? t('auth.changePasswordPlaceholder') : t('auth.passwordPlaceholder')}
                value={formData.password}
                onChange={handleChange}
                required
                autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
              />
              {mode === 'change-temp-password' && (
                <p className="auth__hint">{t('auth.strongPasswordHint')}</p>
              )}
            </div>
          )}

          {/* Confirm Password - For register, reset, and change-temp-password */}
          {(mode === 'register' || mode === 'reset' || mode === 'change-temp-password') && (
            <div className="auth__field">
              <label className="auth__label">
                <LockIcon />
                {t('auth.confirmPassword')}
              </label>
              <input
                type="password"
                name="confirmPassword"
                className="auth__input"
                placeholder={t('auth.confirmPasswordPlaceholder')}
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                autoComplete="new-password"
              />
            </div>
          )}

          {/* Verification Code - For verify email mode */}
          {mode === 'verify-email' && (
            <>
              <div className="auth__field">
                <label className="auth__label">
                  <ScrollIcon />
                  {t('auth.verificationCode')}
                </label>
                <input
                  type="text"
                  name="verificationCode"
                  className="auth__input auth__input--code"
                  placeholder={t('auth.verificationCodePlaceholder')}
                  value={formData.verificationCode}
                  onChange={handleChange}
                  maxLength="6"
                  pattern="\d{6}"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  required
                  style={{
                    fontSize: '24px',
                    letterSpacing: '8px',
                    textAlign: 'center',
                    fontFamily: 'monospace'
                  }}
                />
                <div className="auth__verification-info">
                  <p className="auth__hint">
                    {t('auth.codeSentTo')} <strong>{registrationEmail}</strong>
                  </p>
                  {remainingAttempts < 5 && (
                    <p className="auth__attempts" style={{ color: remainingAttempts <= 2 ? '#ff4444' : '#ffaa00' }}>
                      ⚠️ {t('auth.attemptsRemaining', { n: remainingAttempts, s: remainingAttempts !== 1 ? 's' : '' })}
                    </p>
                  )}
                </div>
              </div>
            </>
          )}

          {/* Error message */}
          {error && (
            <div className="auth__error" key={`err-${submitCount}`}>
              ⚠️ {typeof error === 'object' ? error?.message || t('auth.unexpectedError') : error}
            </div>
          )}
          {successMessage && (
            <div className="auth__success">
              ✅ {successMessage}
            </div>
          )}

          {/* Submit button */}
          <button 
            type="submit" 
            className="auth__submit"
            disabled={loading}
          >
            {loading ? (
              <span className="auth__loading">{t('auth.loading')}</span>
            ) : (
              <>
                {submitContent.icon}
                {submitContent.text}
              </>
            )}
          </button>

          {/* Resend Verification - Only in verify-email mode */}
          {mode === 'verify-email' && (
            <button 
              type="button"
              className="auth__forgot-btn"
              onClick={handleResendVerification}
              disabled={loading || timeRemaining === 'expired'}
            >
              {timeRemaining === 'expired' ? t('auth.codeExpired') : t('auth.resendCode')}
            </button>
          )}

          {/* Forgot Password link - Only on login mode */}
          {mode === 'login' && (
            <button 
              type="button"
              className="auth__forgot-btn"
              onClick={() => switchMode('forgot')}
            >
              {t('auth.forgotPassword')}
            </button>
          )}
        </form>

        {/* Divider */}
        <div className="auth__divider">
          <span>⚜️</span>
        </div>

        {/* Switch mode */}
        <div className="auth__switch">
          {mode === 'login' && (
            <>
              <p className="auth__switch-text">{t('auth.noAccount')}</p>
              <button 
                type="button"
                className="auth__switch-btn"
                onClick={() => switchMode('register')}
              >
                {t('auth.createAccount')}
              </button>
            </>
          )}
          
          {mode === 'register' && (
            <>
              <p className="auth__switch-text">{t('auth.haveAccount')}</p>
              <button 
                type="button"
                className="auth__switch-btn"
                onClick={() => switchMode('login')}
              >
                {t('auth.login')}
              </button>
            </>
          )}

          {mode === 'verify-email' && (
            <>
              <p className="auth__switch-text">{t('auth.needToGoBack')}</p>
              <button 
                type="button"
                className="auth__switch-btn"
                onClick={() => switchMode('login')}
              >
                {t('auth.backToLogin')}
              </button>
            </>
          )}
          
          {(mode === 'forgot' || mode === 'reset' || mode === 'change-temp-password') && (
            <>
              <p className="auth__switch-text">{t('auth.rememberPassword')}</p>
              <button 
                type="button"
                className="auth__switch-btn"
                onClick={() => switchMode('login')}
              >
                {t('auth.backToLogin')}
              </button>
            </>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default AuthModal
